var parent = require('../../es/instance/flat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/flat.js
// module id = 1908
// module chunks = 25